import {UPDATE_BULK_POLICY_PAYLOAD , UPDATE_BULK_POLICY_PAYLOAD_SUCCESS , UPDATE_BULK_POLICY_PAYLOAD_RESET, UPDATE_BULK_POLICY_PAYLOAD_ERROR, UPDATE_VALIDATION_RECORDS, SAVE_PROPOSER_DETAILS, SAVE_BULK_FILE_URL, SAVE_BULK_QUOTATION_NUMBER, SAVE_ADDON_DATA, CLEAR_ADDON_DATA} from '../actionTypes';

export const SAVE_VALIDATION_DATA = 'SAVE_VALIDATION_DATA';
export const SAVE_DISCOUNT_DATA = 'SAVE_DISCOUNT_DATA';
export const UPDATE_DISCOUNTED_RECORDS = 'UPDATE_DISCOUNTED_RECORDS';
export const CLEAR_DISCOUNT_DATA = 'CLEAR_DISCOUNT_DATA';
export const updateValidationRecords = (records) => ({
  type: UPDATE_VALIDATION_RECORDS,
  payload: records,
});

export const bulkPolicy = (policy) => {
  console.log(policy, 'inside bulkPolicy')
    return ({
        type: UPDATE_BULK_POLICY_PAYLOAD,
        payload: {policy}
    })
}
  
export const bulkPolicySuccess = (data) => ({
  type: UPDATE_BULK_POLICY_PAYLOAD_SUCCESS,
  payload: data,
});

export const bulkPolicyReset = () => ({
  type: UPDATE_BULK_POLICY_PAYLOAD_RESET,
});

export const bulkPolicyError = (error) => ({
  type: UPDATE_BULK_POLICY_PAYLOAD_ERROR,
  payload: error,
});

// New actions for validation and discount data
export const saveValidationData = (validationData) => ({
  type: SAVE_VALIDATION_DATA,
  payload: validationData,
});

export const saveDiscountData = (discountData) => ({
  type: SAVE_DISCOUNT_DATA,
  payload: discountData,
});

export const updateDiscountedRecords = (discountedRecords) => ({
  type: UPDATE_DISCOUNTED_RECORDS,
  payload: discountedRecords,
});

export const clearDiscountData = () => ({
  type: CLEAR_DISCOUNT_DATA,
});

// Save proposer-level details that are common for all validated records
export const saveProposerDetails = (proposerDetails) => ({
  type: SAVE_PROPOSER_DETAILS,
  payload: proposerDetails,
});

// Save the bulk upload Excel file URL
export const saveBulkFileUrl = (fileUrl) => ({
  type: SAVE_BULK_FILE_URL,
  payload: fileUrl,
});

// Save the bulk quotation number returned after saving quotation
export const saveBulkQuotationNumber = (quotationNumber) => ({
  type: SAVE_BULK_QUOTATION_NUMBER,
  payload: quotationNumber,
});

// Save per-record addon state (selectedServices, additionalCost, individualAddonCosts)
export const saveAddonData = (addonData) => ({
  type: SAVE_ADDON_DATA,
  payload: addonData,
});

// Clear all per-record addon state
export const clearAddonData = () => ({
  type: CLEAR_ADDON_DATA,
});